import { Box, Dialog } from "@mui/material"
import { Buttons } from "../../../core/global/Buttons";
import { domain } from "../../../core/Env";

export const Welcome = ({history, onboarding, noSidebar, Cafgu, tool_state}) => {
    const handleClose = async() => {
        // noSidebar.set('/profile');
        // history.push('/profile?account=setup');
        const subc = btoa(JSON.stringify({ action: 'profiling', returncb: domain('tool').url }))
        window.location.href = `${domain('psl').url}/sso/account/auth?ainfo=${encodeURIComponent(JSON.stringify(tool_state.__SESSION.data.ainfo))}&subcb=${subc}`
    };

  return (
        <Dialog open={onboarding.data.profiling} PaperProps={{ sx:{ borderRadius: '16px'}}} BackdropProps={{sx: {backgroundColor: 'rgba(0, 0, 0, 75%)'}}}>
            <Box maxWidth={420}>
                <img src={Cafgu} alt="cafgu-img" />
                <Box textAlign="center" pb={2} px={2}>
                    <Box fontSize={24} fontWeight="bold">Welcome to</Box>
                    <Box mb="16px" fontSize={24} fontWeight="bold">POFAcademy</Box>
                    <Box fontSize={12} className="line-height" color="#000">My name is CAFGU, and I'm your coach. Let me guide you on your journey to becoming an extraordinary one.</Box>
                    
                    <Box fontSize={12} mt={2} display="flex" justifyContent="center">
                        <Box>To continue,</Box> <Box color="primary.main" px={.5}> set up your account </Box> <Box> details first.</Box>
                    </Box>
                    <Box display="flex" justifyContent="center" my={3}>
                        <Buttons event={()=>handleClose()} variant="contained" borderRadius="8px" color="primary" width="96.56px" height="47px" fontSize="14px" text="Continue"/>
                    </Box>
                    <Box display="flex" alignItems="center" justifyContent="center" >
                        <Box width={24} height={4} bgcolor="#0984E3" borderRadius={4} mr={1} />
                        <Box width={24} height={4} bgcolor="#E4E4E4" borderRadius={4} />
                    </Box>
                </Box>
            </Box>
        </Dialog>
    )
}
